import React, {Component} from 'react';
import { connect} from 'react-redux'
import {bindActionCreators, compose} from 'redux'
import CTable from '@/components/CTable'
import CInput from '@/components/CForm/CInput'
import CButton from '@/components/CButton'
import CBaseComponent from '@/components/CBaseComponent'
import { withRouter} from 'react-router-dom'
import { tableData,tableData1} from './table2'
import './select.scss'
import{gepprovincelist} from "../../utils/gepdatadef";

import {selectLibraryHeader} from "../../servers/goodsManageApi";
import {
    setLbname,
    setLibrary,
    setScoreInfo,
    setMenu, refreshMenu,setLibraryArr
} from "../../redux/common/action";
import CSelect from "../../components/CForm/CSelect";
@CBaseComponent
class Select extends Component{
    constructor(props) {
        super(props);
        this.onTableChange = this.onTableChange.bind(this);
        this.searchHandler = this.searchHandler.bind(this);
        this.searchTable = this.searchTable.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        // reload时重新加载数据
        // this.getDeleteUserListData();
        // this.getUserBussinesRoleListData();
    }


    state = {
        columns: tableData.tHead,
        dataSourceAll:[],
        dataSource: tableData.tBody,
        columns1: tableData1.tHead,
        dataSource1: tableData1.tBody,
        dataSource1all: tableData1.tBody,
        page: tableData.tPage,
        loading: true,
        museumname:'',
        provinve:gepprovincelist,
        provinceid:'',
        level:[
            {name:'一级',id:1410},
            {name:'二级',id:1411},
            {name:'三级',id:1412},
        ],
        levelid:'',
    };

    onTableChange(data){
        let d = JSON.parse(JSON.stringify(this.state.dataSourceAll))
        var bIndex = parseInt(data.data.pageSize) * (parseInt(data.data.page) - 1);
        var eIndex = parseInt(bIndex) + parseInt(data.data.pageSize);
        var newDataList = [];
        for(var i = bIndex;i < eIndex;i++){
            if (d[i]) {
                newDataList.push(d[i]);
            }
        }
        this.setState({
            page: {...this.state.page, ...data.data},
            dataSource:newDataList
        })
    }

    searchHandler(value,type){
        this.setState({
            [type]:value
        })
    }

    getAlert(data){
        const params = {
            museumid:data.id,
        }
        selectLibraryHeader(params).then(res=>{
            const result = res.records[0].scorelist
            this.props.setLibraryArr(result)
            this.props.setLibrary(data.id)
            this.props.setLbname(data.name)
            localStorage.setItem('chooseid','23131010')
            this.props.history.push({
                pathname: '/informationDeclaration/museumbaseinfo/baseScore',
            });
            this.props.refreshMenu(true)
        })
    }

    componentWillMount(){

    }

    searchTable(){
        this.props.onClick(this.state.museumname,this.state.provinceid,this.state.levelid)
    }

    componentWillReceiveProps(nextProps) {
        let d = JSON.parse(JSON.stringify(nextProps.data))
        let  data = d.splice((nextProps.pagedata.page-1)*nextProps.pagedata.pageSize,nextProps.pagedata.page*nextProps.pagedata.pageSize)
        this.setState({
            dataSourceAll:nextProps.data,
            dataSource:data,
            loading:false,
            page:nextProps.pagedata
        })
    }

    componentDidMount(){
    }
    render(){
        return (
            <div className='history-record-delete-user-list' style={{width:'100%'}}>
                <div className='flex filter-wrap'>
                    <div className='flex filter-left'>
                        <h3>参与评分博物馆</h3>
                    </div>
                    <div className='flex filter-right'>
                      <CInput value={this.state.museumname}
                                     className='search-input'
                                     placeholder='请输入博物馆名称'

                                     onChange={(value)=>this.searchHandler(value,'museumname')} />
                        <CSelect value={this.state.provinceid} options={this.state.provinve} placeholder='请选择所处省份'  onChange={(value)=>this.searchHandler(value,'provinceid')}/>
                        <CSelect value={this.state.levelid} options={this.state.level} placeholder='请选择申报等级'  onChange={(value)=>this.searchHandler(value,'levelid')}/>
                        <CButton type='primary' onClick={this.searchTable}>搜索</CButton>
                    </div>
                </div>
                <CTable ref='historyRecordDeleteUserList' checked={false} loading={false} columns={this.state.columns} dataSource={this.state.dataSource} page={this.state.page} onTableChange={this.onTableChange}>
                    <div
                        slot='index'
                        render={(text, record, index) => (
                            <div className='operate'>
                                {index+1}
                            </div>
                        )} />
                    <div
                        slot='operatehz'
                        render={(text, record, index) => (
                            <div className='operate'>
                                <CButton type='text' size="mini" onClick={() => this.getAlert(record)}>
                                    查看
                                </CButton>
                            </div>
                        )} />
                </CTable>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        scoreinfo: state.scoreinfo,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setScoreInfo:bindActionCreators(setScoreInfo,dispatch),
        setLibrary: bindActionCreators(setLibrary, dispatch),
        setLbname: bindActionCreators(setLbname, dispatch),
        setLibraryArr: bindActionCreators(setLibraryArr, dispatch),
        setMenu:bindActionCreators(setMenu,dispatch),
        refreshMenu: bindActionCreators(refreshMenu, dispatch),
    };
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(Select);
